import axios, { AxiosResponse } from "axios"

export default class ApiClient {
  baseUrl = window.runtimeEnv.VUE_APP_API_URL

  async get (route: string, options = {}): Promise<AxiosResponse> {
    return axios.get(this.baseUrl + route, options)
  }

  async post (route: string, options = {}, config = {}): Promise<AxiosResponse> {
    return axios.post(this.baseUrl + route, options, config)
  }

  async put (route: string, options = {}): Promise<AxiosResponse> {
    return axios.put(this.baseUrl + route, options)
  }

  async patch (route: string, options = {}): Promise<AxiosResponse> {
    return axios.patch(this.baseUrl + route, options)
  }

  async delete (route: string, options = {}): Promise<AxiosResponse> {
    return axios.delete(this.baseUrl + route, options)
  }
}
